import { useEffect } from 'react';
import { createHostMicroFrontendManager } from '../managers/hostMicroFrontend';
export const useHostMicroFrontendApi = () => {
    useEffect(() => {
        if (!window.hostMicroFrontendApi) {
            window.hostMicroFrontendApi = createHostMicroFrontendManager();
        }
    }, []);
    return window.hostMicroFrontendApi;
};
